import type { ReactNode } from 'react';

export type PillTone = 'success' | 'error' | 'warning' | 'info' | 'neutral' | 'brand';

const TONE_COLOR: Record<PillTone, string> = {
  success: 'var(--co-success)',
  error: 'var(--co-error)',
  warning: 'var(--co-warning)',
  info: 'var(--co-info)',
  neutral: 'var(--co-muted)',
  brand: 'var(--co-brand)',
};

interface Props {
  tone: PillTone;
  children: ReactNode;
  title?: string | undefined;
}

/** Tinted pill (text = token, background = 12% mix of it), the same treatment
 *  as CallbackLogs/StatusPill and TestPlayers/Badge — nothing hardcoded. */
export function Pill({ tone, children, title }: Props) {
  const color = TONE_COLOR[tone];
  return (
    <span
      data-tone={tone}
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ color, backgroundColor: `color-mix(in srgb, ${color} 12%, transparent)` }}
      {...(title ? { title } : {})}
    >
      {children}
    </span>
  );
}
